import React, { useMemo } from "react";

interface SparklineProps {
  values: number[];
  width?: number;
  height?: number;
  strokeClassName?: string;
  className?: string;
}

const Sparkline: React.FC<SparklineProps> = ({
  values,
  width = 120,
  height = 40,
  strokeClassName = "stroke-gray-400",
  className = "",
}) => {
  const path = useMemo(() => {
    if (!values || values.length === 0) return "";
    const finiteValues = values.filter((v) => Number.isFinite(v));
    if (finiteValues.length === 0) return "";

    const min = Math.min(...finiteValues);
    const max = Math.max(...finiteValues);
    const range = max - min || 1;

    const stepX = width / Math.max(values.length - 1, 1);

    const points = values.map((v, i) => {
      const yNorm = (v - min) / range; // 0..1
      const y = height - yNorm * height; // invert for SVG
      const x = i * stepX;
      return [x, y] as const;
    });

    return points
      .map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(2)},${y.toFixed(2)}`)
      .join(" ");
  }, [values, width, height]);

  if (!path) return null;

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      height={height}
      className={className}
    >
      <path d={path} className={`${strokeClassName}`} fill="none" strokeWidth={2} />
    </svg>
  );
};

export default Sparkline;


